<template>
  <div class="footer-box">
  <div class="footer w1200" :class="{'index-path': $route.name === ROUTER_MAP.home}">
    <p>
<!--      <a>关于我们</a>-->
<!--      <a>联系我们</a>-->
<!--      <a>帮助中心</a>-->
<!--      <router-link v-if="!userInfo.access_token" to="/teacher-login">教师登录</router-link>-->
    </p>
    <p>
<!--      <span>客服电话：400-188-8181</span>-->
<!--      <span>Copyright © 2020 </span>-->
<!--      <span>北京智学树课程研发中心</span>-->
<!--      <span>版权所有</span>-->
    </p>
  </div>
  </div>
</template>

<script>
import ROUTER_MAP from '@/router/router-map'
import {mapState} from 'vuex'
export default {
  components: {},
  data() {
    return {
      ROUTER_MAP
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
};
</script>
<style lang="less" scoped>
.footer-box {
  width: 100%;
  margin-top: 36px;
}
.footer {
  height: 80px; /* no */
  p{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        a {
          color: #8B95A0;
          padding: 0 25px;
        }
        span {
          color: #9EA6B0;
          padding: 0 8px;
        }
        &:nth-child(1) {
          font-size: 18px;
          margin-bottom: 10px;
        }
    }
}
.footer.index-path {
      p{
        a {
          color: @primary-color;
        }
        span {
          color: @primary-color;
        }
    }
}
</style>
